import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyProfile } from "../../features/profile/profileSlice";
import { useLocation, useParams } from "react-router-dom";
import { AppBar, Box, IconButton, TextField, Toolbar } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import * as signalR from "@microsoft/signalr";
import { GetMyPosition, GetPositionById } from "../../services/PositionService";
import { GetGroups } from "../../services/MessagingService";
import NumberFormat from "react-number-format";
import {
  fetchGroups,
  selectAllGroups,
  updateGroups,
} from "../../features/messages/groupsSlice";
import Message from "./Message";
import { ConsoleLogger, sendMessage } from "@microsoft/signalr/dist/esm/Utils";
import { SendMessage } from "../../services/MessageService";
import { string } from "yup";
import {
  GetMyNotices4Chat,
  GetMyNotices4Chat2,
  GetNoticeById,
} from "../../services/NoticeService";
import GroupCard from "./GroupCard";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import axios from "axios";
import { GURL } from "../../services/global";
import GroupCardHeader from "./GroupCardHeader";
import {
  Button,
  Checkbox,
  Collapse,
  InputRef,
  Modal,
  Space,
  Switch,
  Table,
  Timeline,
  message,
} from "antd";
import { Input } from "antd";
import { CheckOutlined, ChildCare, SearchOutlined } from "@mui/icons-material";
import {
  AddNoticeDetailsAnswereApi,
  AddNoticeLevelChangeApi,
  GetAllGroupsNoticesByPositionId,
  GetGroupIdByNoticeIdAndPositionId,
  GetGroupsByNoticeId,
  GetNoticeDetailsAnswere,
  GetNoticeDetailsAnsweresForCompareByNoticeId,
  GetNoticeDetailsAnsweresTableByGroupId,
  GetNoticeLevelChangesByGroupId,
} from "../../services/GroupService";
import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ICellRendererParams, ModuleRegistry } from "@ag-grid-community/core";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { BaseGridOptions } from "../../extentions/CustomGridOptions";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";
import { NoneODataServerSideDatasource } from "../../extentions/NoneODataServerSideDataSource";
import { ClockCircleOutlined } from "@ant-design/icons";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { Units } from "../../helpers/Units";
import { ColumnsType } from "antd/es/table";
import {
  ColumnType,
  FilterConfirmProps,
  TableRowSelection,
} from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import { Button as AntButton, Popover } from "antd";
import { log } from "@grpc/grpc-js/build/src/logging";
import InputWithIcons from "../share/InputWithIcons";
import GroupNotice from "./GroupNotice";
import { getMyPosition } from "../../features/position/positionSlice";

ModuleRegistry.registerModules([ServerSideRowModelModule]);
const Chat2 = () => {
  // Start PriceLog Control
  const [getPriceLogVisiblity, setPriceLogVisiblity] = useState(false);

  useEffect(() => {
    console.log("getPriceLogVisiblity", getPriceLogVisiblity);
  }, [getPriceLogVisiblity]);
  //End PriceLog Control

  var enterprise = require("@ag-grid-enterprise/core");
  enterprise.LicenseManager.setLicenseKey(
    "DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6"
  );
  const gridRef = useRef(null);

  const [openEmoji, setOpenEmoji] = useState(false);
  const [getUpDateNotices, setUpDateNotices] = useState(true);
  const [getGroupsFilter, setGroupsFilter] = useState("");
  useEffect(() => {
    console.log("getGroupsFilter", getGroupsFilter);
  }, [getGroupsFilter]);
  const location = useLocation();
  const [msgs, setMsgs] = useState<any>(null);
  const myProfile = useSelector(getMyProfile);
  const dispatch = useDispatch<any>();
  const [getUserInfo, setUserInfo] = useState<any>(null);
  const groupList = useSelector(selectAllGroups);
  const [getContent, SetContetnt] = useState("");
  const GroupsStatus = useSelector((state) => (state as any).groups.status);
  const [myPositionGroupId, setMyPositionGroupId] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [getMyPositionData, SetMyPositionData] = useState<any>(null);
  const [File1, SetFile1] = useState<any>(null);
  const [data, SetData] = useState<any>();
  const [failed, Setfailed] = useState<any>();
  const [GetNoticeLevelChanges, SetNoticeLevelChanges] = useState<any>([]);
  const [getAnsweres, setAnsweres] = useState<any>([]);
  const [GetShowCompareTableVisibleModal, SetShowCompareTableVisibleModal] =
    useState<any>(false);
  const [GetShowCompareTableModal, SetShowCompareTableModal] =
    useState<any>(false);
  const [GetShowCompareTableModalData, SetShowCompareTableModalData] =
    useState<any>([]);
  const [
    GetShowAnsweresCancelWhenUnsavedModal,
    SetShowAnsweresCancelWhenUnsavedModal,
  ] = useState<any>(false);
  const [GetShowAnsweresTableModal, SetShowAnsweresTableModal] =
    useState<any>(false);
  const [GetShowNoticeStateModal, SetShowNoticeStateModal] =
    useState<any>(false);
  const [GetSetAnswereModal, SetGetSetAnswereModal] = useState<any>(false);
  const h = window.innerHeight;
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const params = useParams();
  const { is } = useParams();
  interface DataTypeCompany {
    key: React.Key;
    companyId: string;
    name: string;
    count: string;
    sumPrice: string;
  }

  const [GetCompareData, SetCompareData] = useState<DataTypeCompany[]>([]);
  const [GetReportsModal, SetReportsModal] = useState<any>(false);
  const [GetNotices4Chat, SetNotices4Chat] = useState<any>([]);
  const openNewWindow = (url: any) => {
    // Open a new window
    const newWindow = window.open(url, "_blank", "width=900,height=800");

    // You can manipulate the new window, for example, set its title
    // newWindow.document.title = "New Window";
  };
  const inputRef = useRef<any>([]);

  const updateScreenHeight = () => {
    setScreenHeight(window.innerHeight);
  };
  async function GetMyPositionAsync() {
    return await GetMyPosition().then((p) => {
      //console.log("mypos", p.data);

      SetMyPositionData(p.data);
    });
  }

  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: (key: any, rows) => {
      console.log(rows);
      setSelectedRowKeys(key);
    },
  };
  const [positionId, setPositionId] = useState(null);

  const myPositions = useSelector(getMyPosition);
  useEffect(() => {
    console.log("glp2", myPositions);

    if (myPositions?.positions?.id !== "") {
      console.log("glpd", myPositions);
      setPositionId(myPositions?.positions?.id);
    }
  }, [myPositions]);
  const chatbox = useRef<null | HTMLDivElement>(null);

  async function SendMessageAsync() {
    if (index > -1 && getContent !== "") {
      await SendMessage({
        message: getContent,
        groupId: groupList[index].id,
        messageTypes: 0,
      }).then(() => SetContetnt(""));
    }
  }
  const [index, setIndex] = useState(-1);

  const updateChildrenForKey = (key: any) => {
    if (key.length <= 0) {
      return;
    }
    GetGroupsByNoticeId(key[0]).then((p) => {
      SetNotices4Chat((prevData: any) =>
        prevData.map((item: any) =>
          item.key === key[0]
            ? {
                ...item,
                children: (
                  <>
                    {p?.data?.data.map((q: any) => {
                      return (
                        <div key={q.id}>
                          {}
                          <div
                            key={q.id}
                            onClick={() => {
                              setSelectedGroup(q.id);
                              setSelectedGroupId(q.id);
                              setSelectedNoticeId(q?.groupRefs[0].noticeId);
                            }}
                            className="     d-flex col-12  "
                            style={{
                              backgroundColor:
                                selectedGroup === q.id
                                  ? "rgba(210, 210, 210,1)"
                                  : "white",
                              width: "100%",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "row",
                              borderRadius: "0px 25px 25px 0px",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              key={q.id}
                              className="col-12"
                              style={{
                                textAlign: "right",
                                paddingRight: "1.5rem",
                              }}
                            >
                              <GroupCard
                                OtherCompanyId={
                                  q?.groupRefs[0].companyId ===
                                  getMyPositionData?.companyId
                                    ? q?.groupRefs[0].applicantCompanyId
                                    : q?.groupRefs[0].companyId
                                }
                                myCompanyName={getMyPositionData?.company?.name}
                                noticeId={q?.groupRefs[0].noticeId}
                                filter={getGroupsFilter}
                              />
                            </div>
                          </div>
                          {}
                        </div>
                      );
                    })}
                  </>
                ),
              }
            : item
        )
      );
    });
  };

  useEffect(() => {
    if (data?.noticeLevels !== undefined) {
      LoadNoticeLevels();
      console.log("did", data.id);

      GetNoticeDetailsAnsweresForCompareByNoticeId(data?.id).then((p) => {
        //console.log("dds", p.data.data);
        SetCompareData([]);
        //SetCompareData(p.data.data);
        p.data.data.map((p: any) => {
          //console.log("P", p);
          SetCompareData((prevItems: any) => [
            ...prevItems,
            {
              key: p.companyId,
              companyId: p.companyId,
              name: p.name,
              count: p.count,
              sumPrice: p.sumPrice,
              forceSupply: p.forceSupply,
            },
          ]);
        });
      });
    }
  }, [data]);

  const LoadNoticeLevels = () => {
    GetNoticeLevelChangesByGroupId(getSelectedGroupId).then((p: any) => {
      // console.log("ddd", p.data.data);

      if (Array.isArray(p?.data?.data)) {
        const levels = p?.data?.data?.map((prop: any) => ({
          noticeLevelId: prop.noticeLevelId,
          isValid: prop.isValid,
          label: (
            <div className="">
              <p style={{ fontSize: "0.70rem" }}>
                {ConvertToShamsi(prop.createDate)} <br />
                <span style={{ color: "red" }}>
                  {prop.modifiedDate !== null
                    ? ConvertToShamsi(prop.modifiedDate)
                    : ""}
                </span>
              </p>
            </div>
          ),
          children:
            prop.isValid === false ? (
              <>
                <s>
                  {
                    data?.noticeLevels[
                      data?.noticeLevels.findIndex(
                        (p: any) => p.id === prop.noticeLevelId
                      )
                    ]?.level
                  }
                </s>
              </>
            ) : (
              <>
                {
                  data?.noticeLevels[
                    data?.noticeLevels.findIndex(
                      (p: any) => p.id === prop.noticeLevelId
                    )
                  ]?.level
                }
              </>
            ),
        }));
        SetNoticeLevelChanges(levels);
      }
    });
  };

  const [getSelectedGroupId, setSelectedGroupId] = useState<any>(null);
  const [getSelectedNoticeId, setSelectedNoticeId] = useState<any>(null);

  useEffect(() => {
    if (getSelectedNoticeId !== undefined && getSelectedNoticeId !== null) {
      console.log("Pos and ", getSelectedNoticeId, "-", getMyPositionData?.Id);

      GetGroupIdByNoticeIdAndPositionId(
        getSelectedNoticeId,
        getMyPositionData?.Id
      ).then((p) => {
        setSelectedGroupId(p.data.data);
        return;
      });
    }
  }, [getSelectedNoticeId, getMyPositionData]);

  useEffect(() => {
    console.log("gl", getSelectedGroupId);

    chatbox?.current?.scrollIntoView(false);

    if (getSelectedNoticeId !== undefined) {
      GetNoticeById(getSelectedNoticeId).then((p: any) => {
        SetData(p.data);
        if (p?.data?.responsiblePositionId !== undefined) {
          GetPositionById(p?.data?.responsiblePositionId).then((p) => {
            if (p?.data?.companyId === getMyPositionData?.companyId) {
              GetNoticeDetailsAnsweresTableByGroupId(getSelectedGroupId).then(
                (p) => {
                  console.log("ddd", p);

                  SetShowCompareTableModalData(p?.data?.data);
                }
              );
              SetShowCompareTableVisibleModal(true);
            } else {
              SetShowCompareTableVisibleModal(false);
            }
          });
        }
      });
      // console.log("myProfile", myProfile);
      //return;
      GetNoticeDetailsAnswere(
        getSelectedGroupId
        // myProfile?.id,
        //getMyPositionData?.id
      )
        .then((p: any) => {
          //console.log("smp", p);
          if (Array.isArray(p?.data?.data)) {
            const answersWithSavedProperty = p.data.data?.map(
              (answer: any) => ({
                ...answer,
                Saved: true,
                Calculated: true,
              })
            );
            setAnsweres(answersWithSavedProperty);
          }
        })
        .then(() => {
          if (is === "1") {
            SetShowAnsweresTableModal(true);
          }
        });
    }
  }, [getSelectedGroupId]);

  useEffect(() => {
    //console.log("gl", groupList);
    if (getSelectedNoticeId !== null && getSelectedNoticeId !== undefined) {
      groupList.some((obj: any) => {
        return obj.groupRefs.some((ref: any) => {
          if (ref.noticeId === getSelectedNoticeId) {
            setSelectedGroup(obj.id);

            return true; // exits the loop once the condition is met
          }
        });
      });
    }
  }, [groupList]);

  const [getNoticeIds, setNoticeIds] = useState<any>();
  useEffect(() => {
    console.log("myProfile", getMyPositionData);
    if (getMyPositionData !== null) {
      GetAllGroupsNoticesByPositionId(getMyPositionData.id).then((p) => {
        setNoticeIds(p.data.data);
      });
    }
  }, [getMyPositionData]);

  useEffect(() => {
    if (getNoticeIds !== undefined) {
      console.log("getNoticeIds", getNoticeIds);

      GetMyNotices4Chat2({
        noticeIds: getNoticeIds,
        isPublished: getUpDateNotices,
      }).then((p) => {
        const transformedData = p.data.data
          .sort(
            (a: any, b: any) =>
              new Date(b.createdDate).getTime() -
              new Date(a.createdDate).getTime()
          )
          .filter((f: any) =>
            getUpDateNotices ? f.noticeState === 5 : f.noticeState === 6
          )
          .map((item: any) => ({
            label: (
              <>
                {
                  <div
                    style={{
                      backgroundColor:
                        item.noticeState !== 5 ? "transparent" : "transparent",
                    }}
                  >
                    {item.title}
                  </div>
                }
              </>
            ),
            title: item.title,
            key: item.id,
            noticeState: item.noticeState,
            children: <></>,
          }));
        SetNotices4Chat(transformedData);
      });
    }
  }, [getNoticeIds, getUpDateNotices]);
  useEffect(() => {
    console.log("GetNotices4Chat", GetNotices4Chat);
  }, [GetNotices4Chat]);

  useEffect(() => {
    GetMyPositionAsync();
    setSelectedNoticeId(params.id);
    dispatch(fetchGroups());
  }, []);

  useEffect(() => {
    if (selectedGroup) {
      console.log("sg", selectedGroup);

      const index = groupList.findIndex((f: any) => f.id === selectedGroup);
      setIndex(index);
      console.log(index);
      console.log("msg", groupList[index]?.messages);

      console.log(
        "my log",
        groupList[index]?.messages?.filter((f: any) => f.messageTypes !== 7)
      );

      //setMsgs(groupList[index].messages);
      // setMyPositionGroupId(groupList[index].myPositionGroupId); i commented i dont know why ?
    }
  }, [selectedGroup]);

  useEffect(() => {
    if (File1) {
      const formData = new FormData();
      formData.append("file", File1);
      formData.append("message", getContent);
      formData.append("groupId", groupList[index].id);
      formData.append("messageTypes", "2");

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(`${GURL}/Messaging/v1/Messages`, formData, config)
        .then((response) => {
          //GetFilesAsync(GetNoticeId);
          // console.log("response", groupList[index].id);
        })
        .catch((error) => {
          // Handle errors
        });
    }
  }, [File1]);

  const SetAnswereForNoticeDetail = (id: any, name: any, value: any) => {
    Setfailed(null);
    const index = getAnsweres.findIndex((p: any) => p.noticeDetailId === id);
    console.log("index , name , value", index, name, value);
    console.log(
      "cnt",
      data.noticeDetails[data.noticeDetails.findIndex((p: any) => p.id === id)]
        .count
    );

    if (index === -1) {
      setAnsweres((prevItems: any) => [
        ...prevItems,
        {
          noticeDetailId: id,
          ["Saved"]: false,
          ["Calculated"]: false,
          ["count"]:
            name !== "count"
              ? data.noticeDetails[
                  data.noticeDetails.findIndex((p: any) => p.id === id)
                ].count
              : value.replace(/[^0-9]/g, ""),
          ["price"]: name !== "price" ? 0 : value.replace(/[^0-9]/g, ""),
          [name]: name !== "description" ? value.replace(/[^0-9]/g, "") : value,
        },
      ]);
    } else {
      console.log("cntC", getAnsweres[index]);

      setAnsweres((prevItems: any) =>
        prevItems?.map((item: any) =>
          item.noticeDetailId === id
            ? {
                ...item,
                ["Saved"]: false,
                ["Calculated"]: false,
                [name]:
                  name !== "description" ? value.replace(/[^0-9]/g, "") : value,
              }
            : item
        )
      );
    }
  };
  const SaveAnswereForNoticeDetail = (id: any) => {
    const answereIndex = getAnsweres.findIndex(
      (p: any) => p.noticeDetailId === id
    );

    if (answereIndex !== -1) {
      // console.log(
      //   "ans",
      //   getAnsweres[answereIndex]?.count?.toString().replace(/,/g, "")
      // );
      // console.log(
      //   "dat",
      //   data.noticeDetails[
      //     data.noticeDetails.findIndex((p: any) => p.id === id)
      //   ].count
      // );

      if (
        getAnsweres[answereIndex].description === undefined ||
        getAnsweres[answereIndex].description === "" ||
        getAnsweres[answereIndex].description.trim() === ""
      ) {
        message.error(
          `
         لطفا برای
         ${
           data.noticeDetails[
             data.noticeDetails.findIndex((p: any) => p.id === id)
           ].title
         }
         
         قسمت توضیحات را نیز تکمیل نمایید
         `
        );
        return;
      }

      if (
        getAnsweres[answereIndex]?.count?.toString().replace(/,/g, "") >
        data.noticeDetails[
          data.noticeDetails.findIndex((p: any) => p.id === id)
        ].count
      ) {
        Setfailed(id);

        inputRef.current[id]!.focus({
          cursor: "all",
        });
        return;
      }

      AddNoticeDetailsAnswereApi(
        data.noticeDetails[
          data.noticeDetails.findIndex((p: any) => p.id === id)
        ].vat,
        getAnsweres[answereIndex]?.totalPrice?.toString().replace(/,/g, ""),
        getAnsweres[answereIndex]?.totalVat?.toString().replace(/,/g, ""),
        getAnsweres[answereIndex]?.totalPriceWithVat
          ?.toString()
          .replace(/,/g, ""),
        getAnsweres[answereIndex]?.count?.toString().replace(/,/g, ""),
        id,
        groupList[index].id,
        getAnsweres[answereIndex]?.price?.toString().replace(/,/g, ""),
        getAnsweres[answereIndex]?.description,
        null,
        getMyPositionData.id,
        getMyPositionData.companyId
      )
        .then(async () => {
          await SendMessage({
            message:
              " پیشنهاد " +
              "  " +
              getAnsweres[answereIndex]?.price
                ?.toString()
                ?.replace(/[^0-9]/g, "")
                ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
              " بابت " +
              data.noticeDetails[
                data.noticeDetails.findIndex((p: any) => p.id === id)
              ].title +
              " " +
              "را ثبت کرد",
            groupId: groupList[index].id,
            messageTypes: 7,
          });
        })
        .then(() => {
          // console.log("notID", id);

          setAnsweres((prevItems: any) =>
            prevItems?.map((item: any) =>
              item.noticeDetailId === id ? { ...item, ["Saved"]: true } : item
            )
          );
        });
    }
  };

  const handleUpdateToCalculate = () => {
    // Check if there's any answer with Saved set to false
    const hasUnsavedAnswers = getAnsweres.some(
      (answer: any) => !answer.Calculated && !answer.Saved
    );
    //  console.log("hasUnsavedAnswers", hasUnsavedAnswers);

    // If there are unsaved answers, update their prices
    if (hasUnsavedAnswers) {
      const updatedAnswers = getAnsweres.map((answer: any) =>
        answer.Calculated === false &&
        answer.Saved === false &&
        answer.count !== undefined &&
        answer.price !== undefined
          ? {
              ...answer,
              totalPrice:
                Number.parseInt(answer.price) * Number.parseInt(answer.count),
              totalVat: Math.round(
                Number.parseInt(answer.price) *
                  Number.parseInt(answer.count) *
                  Number.parseFloat(
                    data.noticeDetails[
                      data.noticeDetails.findIndex(
                        (p: any) => p.id === answer.noticeDetailId
                      )
                    ].vat
                  )
              ),

              totalPriceWithVat: Math.round(
                Number.parseInt(answer.price) * Number.parseInt(answer.count) +
                  Number.parseInt(answer.price) *
                    Number.parseInt(answer.count) *
                    Number.parseFloat(
                      data.noticeDetails[
                        data.noticeDetails.findIndex(
                          (p: any) => p.id === answer.noticeDetailId
                        )
                      ].vat
                    )
              ),
              Calculated: true,
            }
          : answer
      );
      //console.log("updatedAnswers", updatedAnswers);
      setAnsweres(updatedAnswers);
    }
  };

  useEffect(() => {
    if (getAnsweres !== null && getAnsweres !== undefined) {
      handleUpdateToCalculate();
    }
    //console.log("getAnsweres", getAnsweres);
  }, [getAnsweres]);
  const CellRendererForDateTime: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState(false);

    return <>{ConvertToShamsi(value)}</>;
  };
  const PositionCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");

    axios
      .get(`${GURL}/Company/v1/position/GetPositionById?id=${value}`)
      .then((response) => {
        //00console.log("RER");
        //console.log(response.data);

        setCellValue(response.data.name); // ;
        //  console.log(cellValue);

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
      });

    return <span>{cellValue}</span>;
  };

  const CompanyCellRenderer2 = (value: any) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");

    axios
      .get(`${GURL}/Company/v1/Company/GetById?id=${value}`)
      .then((response) => {
        //00console.log("RER");
        //console.log("ddd",response.data.data.name);

        setCellValue(response.data.data.name); // ;
        //  console.log(cellValue);

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
      });

    return <span>{cellValue}</span>;
  };

  const CompanyCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");

    axios
      .get(`${GURL}/Company/v1/Company/GetById?id=${value}`)
      .then((response) => {
        //00console.log("RER");
        //console.log("ddd",response.data.data.name);

        setCellValue(response.data.data.name); // ;
        //  console.log(cellValue);

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
      });

    return <span>{cellValue}</span>;
  };
  const PriceCellRendrer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");

    return (
      <span>
        {value
          ?.toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </span>
    );
  };
  const NoticeDetailsCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");
    const title =
      data?.noticeDetails[
        data?.noticeDetails.findIndex((p: any) => p.id === value)
      ].title;

    //  setCellValue(response.data.name); // ;
    //  console.log(cellValue);

    // Return data to Ag Grid

    return <span>{title}</span>;
  };
  interface CustomCellRendererProps {
    record: any; // Replace 'RecordType' with the actual type of your data
    dataIndex: string;
  }

  const PriceAntdCellRendrer: React.FC<CustomCellRendererProps> = ({
    record,
    dataIndex,
  }) => {
    return (
      <span>
        {record.sumPrice
          ?.toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </span>
    );
  };

  const CustomCellRenderer: React.FC<CustomCellRendererProps> = ({
    record,
    dataIndex,
  }) => {
    const [data, setData] = useState<string | null>(null);
    // console.log("rec",record.companyId);

    useEffect(() => {
      const fetchData = async () => {
        try {
          axios
            .get(`${GURL}/Company/v1/Company/GetById?id=${record.companyId}`)
            .then((response) => {
              //00console.log("RER");
              //console.log("ddd",response.data.data.name);

              setData(response.data.data.name); // ;
              //  console.log(cellValue);

              // Return data to Ag Grid
            });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }, [record.id, dataIndex]);

    return <span>{data}</span>;
  };

  interface DataType {
    key: string;
    name: string;
    age: number;
    address: string;
  }

  type DataIndex = keyof DataType;

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const compareValues = (a: any, b: any) => {
    // Handle different data types and null/undefined values
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b);
    } else {
      return a - b;
    }
  };

  const columnsTotal: ColumnsType<any> = [
    {
      title: "فروشگاه",
      dataIndex: "name",
      key: "name",
      width: "30%",

      //   render:(text: string, record: any) => (
      // 	<CustomCellRenderer record={record} dataIndex="companyId" />
      //   ),
      ...getColumnSearchProps("name"),
    },
    {
      title: "مبلغ کل",
      dataIndex: "sumPrice",
      key: "sumPrice",
      width: "20%",
      render: (text: string, record: any) => (
        <PriceAntdCellRendrer record={record} dataIndex="companyId" />
      ),
      sorter: (a, b) => compareValues(a.sumPrice, b.sumPrice),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "تعداد اقلام  ",
      dataIndex: "count",
      key: "count",
      width: "20%",
      sorter: (a, b) => compareValues(a.count, b.count),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "گزارش اقلام",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <Button
          type="primary"
          onClick={() =>
            openNewWindow(
              `${window.location.origin}/iframe/reportNoticeDetails?companyId=${record.key}&noticeId=${data.id}`
            )
          }
        >
          پرینت اقلام
        </Button>
      ),
    },
    // {
    //   title: 'Address',
    //   dataIndex: 'address',
    //   key: 'address',
    //  // ...getColumnSearchProps('address'),
    //  // sorter: (a, b) => a.address.length - b.address.length,
    //  // sortDirections: ['descend', 'ascend'],
    // },
  ];

  const columnsTotal2 = [
    // {
    //   field: "userId",
    //   headerName: "نام و نام خانوادگی",
    //   hide: false,
    //   sortable: false,
    //   filter: false,
    //   width: 300,
    //   // cellRenderer: CategoryCellRenderer,
    // },
    {
      field: "companyId",
      headerName: "فروشگاه",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      cellRenderer: CompanyCellRenderer,
    },
    // {
    //   field: "positionId",
    //   headerName: "فروشگاه",
    //   hide: false,
    //   sortable: false,
    //   filter: false,
    //   width: 300,
    //   // cellRenderer: CategoryCellRenderer,
    // },
    {
      field: "sumPrice",
      headerName: "مبلغ",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      cellRenderer: PriceCellRendrer,
    },
    {
      field: "count",
      headerName: "تعداد اقلام",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      cellRenderer: PriceCellRendrer,
    },
    {
      field: "createDate",
      headerName: "تاریخ پیشنهاد",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      cellRenderer: CellRendererForDateTime,
    },

    {
      field: "id",
      hide: true,
      filter: true,
    },
  ];

  const columns = [
    {
      field: "noticeDetailId",
      headerName: "موضوع",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      cellRenderer: NoticeDetailsCellRenderer,
    },

    {
      field: "positionId",
      headerName: "سمت",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      cellRenderer: PositionCellRenderer,
    },

    {
      field: "price",
      headerName: "مبلغ",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      cellRenderer: PriceCellRendrer,
    },
    {
      field: "description",
      headerName: "توضیحات",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      // cellRenderer: CategoryCellRenderer,
    },
    {
      field: "createDate",
      headerName: "تاریخ پیشنهاد",
      hide: false,
      sortable: false,
      filter: false,
      width: 300,
      cellRenderer: CellRendererForDateTime,
    },

    {
      field: "id",
      hide: true,
      filter: true,
    },
  ];

  const onGridReady = (params: any) => {
    gridApi.current = params.api;
  };

  const gridApi = useRef(null);

  const onFirstDataRendered = () => {
    if (gridApi.current) {
      (gridApi.current as any).sizeColumnsToFit();
    }
  };
  const onLevelChanged = (e: CheckboxChangeEvent, id: any) => {
    console.log(e.target.checked);
    const text = e.target.checked === true ? "فعال" : "غیرفعال";

    AddNoticeLevelChangeApi(
      id,
      groupList[index]?.id,
      myProfile.id,
      getMyPositionData.id,
      e.target.checked
    )
      .then(async () => {
        await SendMessage({
          message:
            getMyPositionData.company.name +
            " " +
            getMyPositionData.name +
            " فرآیند " +
            "  " +
            data?.noticeLevels[
              data?.noticeLevels.findIndex((f: any) => f.id === id)
            ].level +
            "را" +
            " " +
            text +
            " " +
            " کرد",
          groupId: groupList[index].id,
        });
      })
      .then(() => {
        LoadNoticeLevels();
        SetShowNoticeStateModal(false);
      });
  };

  const [formattedValue, setFormattedValue] = useState("");

  const handleInputChange = (event: any) => {
    const inputValue = event.target.value;

    // Remove non-numeric characters
    const numericValue = inputValue.replace(/[^0-9]/g, "");

    // Format the numeric value with a separator every three digits
    const formatted = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    setFormattedValue(formatted);
  };
  const emojiContent = (
    <div>
      <div>
        <div
          onClick={() => SetContetnt(getContent + "😀")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          😀
        </div>
        <div
          onClick={() => SetContetnt(getContent + "😃")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          😃
        </div>
        <div
          onClick={() => SetContetnt(getContent + "😄")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          😄
        </div>
        <div
          onClick={() => SetContetnt(getContent + "😁")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          😁
        </div>
        <div
          onClick={() => SetContetnt(getContent + "😆")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          😆
        </div>
        <div
          onClick={() => SetContetnt(getContent + "😅")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          😅
        </div>
        <div
          onClick={() => SetContetnt(getContent + "🤣")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          🤣
        </div>
        <div
          onClick={() => SetContetnt(getContent + "😂")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          😂
        </div>
        <div
          onClick={() => SetContetnt(getContent + "🙂")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          🙂
        </div>
        <div
          onClick={() => SetContetnt(getContent + "🙃")}
          style={{ cursor: "pointer", display: "inline-block" }}
        >
          🙃
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div
        className="col-12"
        style={{
          backgroundColor: "transparent",
          height: h - 200,
          overflow: "hidden",
        }}
      >
        <div className="col-12 row  ">
          <div
            style={{
              overflowY: "scroll",
              scrollbarWidth: "thin",
              height: h - 200,
              backgroundColor: "transparent",
              textAlign: "center",
            }}
            className="col-3 mt-2  px-2"
          >
            <div
              style={{
                width: "100%",
                backgroundColor: "transparent",
                textAlign: "center",
              }}
            >
              <div style={{ width: "90%", margin: "auto" }}>
                <InputWithIcons
                  LeftIconEnabled={true}
                  LeftIcon={SearchOutlined}
                  size="large"
                  value={getGroupsFilter}
                  onChange={(e) => {
                    setGroupsFilter(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "100%",
                backgroundColor: "transparent",
                textAlign: "center",
              }}
            >
              <div
                className="mt-2 d-flex"
                style={{
                  width: "90%",
                  margin: "auto",
                }}
              >
                <div style={{ width: "20%", textAlign: "right" }}>
                  <Switch onChange={(p) => setUpDateNotices(!p)} />
                </div>
                <div style={{ width: "80%", textAlign: "right" }}>
                  {getUpDateNotices === false
                    ? "آگهی های عدم انتشار"
                    : "آگهی های منتشر شده"}
                </div>
              </div>
            </div>
            <div style={{ height: h, overflow: "scroll" }}>
              <div className="mt-1">
                <Collapse
                  key={getGroupsFilter} // 🔥 Forces re-render when filter changes
                  accordion
                  collapsible="header"
                  destroyInactivePanel={false} // 👈 Keeps child components mounted even when collapsed
                  onChange={(p) => {
                    console.log(p);

                    updateChildrenForKey(p);
                  }}
                  items={
                    getGroupsFilter.replace(/\s+/g, "") !== "" // Remove all spaces from filter
                      ? GetNotices4Chat.filter(
                          (f: any) =>
                            f.title
                              .replace(/\s+/g, "")
                              .toLowerCase()
                              .includes(
                                getGroupsFilter
                                  .replace(/\s+/g, "")
                                  .toLowerCase()
                              ) // Remove all spaces from title
                        )
                      : GetNotices4Chat
                  }
                />
              </div>
            </div>
          </div>
          <div
            className="col-6"
            style={{
              backgroundColor: "transparent",
            }}
          >
            <div
              className="col-12 p-2 card stickTop"
              style={{
                //backgroundColor: "rgb(250, 250, 270)",
                backgroundColor: "transparent",
                borderRadius: "0px 0px 0px 0px ",
                flexDirection: "row",
                justifyContent: "right",
                alignItems: "center",
                textAlign: "right",
              }}
            >
              <div className="col-12 px-2">
                {index > -1 ? (
                  <>
                    <GroupCardHeader
                      OtherCompanyId={
                        groupList[index]?.groupRefs[0].companyId ===
                        getMyPositionData?.companyId
                          ? groupList[index]?.groupRefs[0].applicantCompanyId
                          : groupList[index]?.groupRefs[0].companyId
                      }
                      myCompanyName={getMyPositionData?.company?.name}
                      noticeId={groupList[index]?.groupRefs[0].noticeId}
                      ShowCompareTableModalState={SetShowCompareTableModal}
                      ShowAnsweresTableModalState={SetShowAnsweresTableModal}
                      GetShowCompareTableVisibleModalState={
                        GetShowCompareTableVisibleModal
                      }
                      SetShowNoticeStateModalState={SetShowNoticeStateModal}
                      SetPriceLogVisiblity={setPriceLogVisiblity}
                    />
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        textAlign: "center",
                        alignItems: "center",
                        marginTop: "20rem",
                        position: "absolute",
                        height: h - 200,
                      }}
                      className="col-12 iran"
                    >
                      لطفا یکی از گفتگو ها را انتخاب کنید
                    </div>
                  </>
                )}
              </div>
            </div>

            <div
              style={{
                backgroundColor: "rgba(244, 245, 247, 2)",
                //backgroundColor: "gray",
                display: "inline-block",
                overflowY: "scroll",
                scrollbarWidth: "thin",
                //scrollbarWidth: "thin",
                height: h - 380,
              }}
              className="col-12 "
            >
              {groupList[index]?.messages
                ?.filter((p: any) => {
                  if (getPriceLogVisiblity) return p;
                  return p.messageTypes !== 7;
                })
                ?.map((p: any) => (
                  <div style={{ backgroundColor: "transparent" }} key={p.id}>
                    <> {p.positionsGroupId === myPositionGroupId}</>
                    {p.positionsGroupId === myPositionGroupId ? (
                      <>
                        <div
                          ref={chatbox}
                          key={p.id}
                          className="mt-1 p-2 col-11   "
                          style={{
                            textAlign: "right",
                            backgroundColor: "rgba(205, 209, 228,1)",
                            display: "block",
                            float: "right",
                            marginRight: "10px",
                            borderRadius: "10px 0px 0px 10px",
                          }}
                        >
                          <Message id={p.textMessageId} />
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          ref={chatbox}
                          key={p.id}
                          className="mt-1 p-2 col-11   "
                          style={{
                            textAlign: "left",
                            backgroundColor: "rgba(240, 240, 240,1)",
                            display: "block",
                            float: "left",
                            marginLeft: "10px",
                            borderRadius: "0px 10px 10px 0px",
                          }}
                        >
                          <Message id={p.id} />
                        </div>
                      </>
                    )}
                  </div>
                ))}
            </div>

            <div
              className="d-flex stickBottom"
              style={{
                backgroundColor: "transparent",
                position: "relative",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="col-1 px-2" style={{ textAlign: "left" }}></div>
            </div>
          </div>
          <div
            className="col-3 mt-3"
            style={{
              backgroundColor: "transparent",
            }}
          >
            <div className="my-4 mx-3" style={{ textAlign: "right" }}>
              <h6 className="iran">فرآیند های طی شده این گروه</h6>
              <hr />
              {data?.noticeLevels?.map((p: any) => {
                return (
                  <div key={p.id} style={{ display: "block" }}>
                    <Checkbox
                      disabled={!GetShowCompareTableVisibleModal}
                      key={p.id}
                      checked={
                        GetNoticeLevelChanges.findIndex(
                          (f: any) => f.noticeLevelId === p.id && f.isValid
                        ) > -1
                          ? true
                          : false
                      }
                      onChange={(e) => onLevelChanged(e, p.id)}
                    >
                      {p.level}
                    </Checkbox>{" "}
                  </div>
                );
              })}
            </div>
            <div
              style={{
                height: "24rem",
                overflowY: "scroll",
                overflowX: "hidden",
                scrollbarWidth: "thin",
              }}
            >
              <Timeline mode={"left"} items={GetNoticeLevelChanges} />
            </div>
          </div>
        </div>
        <AppBar
          className=""
          style={{ background: "transparent", zIndex: 0 }}
          position="sticky"
          color="primary"
          sx={{ top: "auto", bottom: 0 }}
        >
          <Toolbar className="p-2" dir="ltr">
            <TextField
              disabled={index <= -1}
              name="content"
              onKeyDown={(e) => {
                if (!e.shiftKey && e.key === "Enter") {
                  SendMessageAsync();
                }
              }}
              onChange={(e) => {
                SetContetnt(e.target.value);
              }}
              style={{ background: "white", borderRadius: "10px" }}
              dir="rtl"
              fullWidth
              placeholder="لطفا چیزی بنویسید . . ."
              id="fullWidth"
              //multiline
              value={getContent}
            />
            <IconButton
              disabled={index <= -1}
              className="mx-4"
              onClick={SendMessageAsync}
              color="default"
            >
              <SendIcon />
            </IconButton>
            <>
              <input
                accept="*"
                onChange={(e) => SetFile1((e as any).target.files[0])}
                style={{ display: "none" }}
                id="file1"
                type="file"
              />
              <label htmlFor="file1">
                <IconButton
                  //variant="outlined"
                  //style={{ height: "100px", width: "100px" }}
                  component="span"
                  className="iran"
                >
                  <AttachFileIcon />
                </IconButton>
              </label>
            </>
            <Popover
              content={emojiContent}
              title="ایموجی"
              trigger="click"
              open={openEmoji}
              onOpenChange={() => setOpenEmoji(!openEmoji)}
            >
              <IconButton
                disabled={index <= -1}
                className="mx-1"
                //onClick={SendMessageAsync}
                color="default"
              >
                <InsertEmoticonIcon />
              </IconButton>
            </Popover>
          </Toolbar>
        </AppBar>
        <Modal
          title="جدول مقایسه"
          open={GetShowCompareTableModal}
          onCancel={() => SetShowCompareTableModal(false)}
          footer={null}
          width={screenWidth - 200}
        >
          <div
            dir="rtl"
            className="mt-2 ag-theme-alpine"
            style={{ width: screenWidth - 250, height: screenHeight - 500 }}
          >
            {data?.id !== undefined ? (
              <>
                <Button
                  className="my-2"
                  type="primary"
                  onClick={() => {
                    const qry = selectedRowKeys
                      .map((key) => `${encodeURIComponent(key)}`)
                      .join(",");
                    openNewWindow(
                      `${window.location.origin}/iframe/report?selectedRowKeys=${qry}&noticeId=${data.id}`
                    );
                    /*SetReportsModal(true)*/
                  }}
                >
                  گزارش
                </Button>
                <div ref={gridRef}>
                  {" "}
                  <Table
                    rowSelection={rowSelection}
                    size="small"
                    dataSource={GetCompareData}
                    pagination={false}
                    columns={columnsTotal}
                  />
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
          <hr />
          <h6>جزئیات</h6>
          <hr />
          <div
            dir="rtl"
            className="mt-2 ag-theme-alpine"
            style={{ width: screenWidth - 250, height: screenHeight - 400 }}
          >
            {data?.id !== undefined ? (
              <>
                <AgGridReact
                  columnDefs={columns}
                  rowModelType={"serverSide"}
                  gridOptions={BaseGridOptions}
                  serverSideDatasource={
                    new NoneODataServerSideDatasource(
                      `Messaging/v1/Groups/GetNoticeDetailsAnsweresTableByGroupId?groupId=${data?.id}`
                    )
                  }
                />
              </>
            ) : (
              <></>
            )}
          </div>
          <Modal
            open={GetReportsModal}
            onCancel={() => SetReportsModal(false)}
            footer={null}
          >
            tst
          </Modal>
        </Modal>

        <Modal
          open={GetShowAnsweresCancelWhenUnsavedModal}
          onCancel={() => SetShowAnsweresCancelWhenUnsavedModal(false)}
          okText={"بله"}
          cancelText={"خیر"}
          onOk={() => {
            SetShowAnsweresCancelWhenUnsavedModal(false);
            SetShowAnsweresTableModal(false);
          }}
        >
          <div style={{ backgroundColor: "transparent", textAlign: "center" }}>
            شما آیتم ذخیره نشده دارید ! آیا مایل به بستن فرم هستید؟
          </div>
        </Modal>

        <Modal
          className="col-12 "
          title="اعلام قیمت"
          open={GetShowAnsweresTableModal}
          onCancel={() => {
            if (getAnsweres.findIndex((f: any) => f.Saved === false) > -1) {
              SetShowAnsweresCancelWhenUnsavedModal(true);
            } else {
              SetShowAnsweresTableModal(false);
            }
          }}
          footer={null}
          width={1400}
        >
          <div style={{ height: "700px", overflow: "scroll" }}>
            <div
              className="col-12"
              style={{
                backgroundColor: "transparent",
                display: "inline-block",

                // borderTop: " 0.01rem solid #8E8786 ",
                //borderBottom: " 0.01rem solid #8E8786 ",
                textAlign: "right",
                marginTop: "1rem",
              }}
            >
              <div
                style={{
                  display: data?.noticeDetails?.length === 0 ? "none" : "block",
                }}
                className="  my-2"
              >
                <table className="mt-2 table-bordered tr  Counter ">
                  <thead style={{ textAlign: "center" }}>
                    <th>#</th>
                    <th>عنوان</th>
                    <th>تعداد / مقدار</th>
                    <th>واحد</th>
                    <th>ارزش افزوده</th>
                    <th> قیمت واحد (ریال)</th>
                    <th> قیمت کل </th>
                    <th> مالیات و عوارض</th>
                    <th> خالص ردیف </th>
                    <th> توضیحات </th>
                    <th> </th>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    {data?.noticeDetails?.map((p: any) => {
                      return (
                        <tr
                          className="numb"
                          style={{
                            backgroundColor:
                              getAnsweres[
                                getAnsweres.findIndex(
                                  (f: any) => f?.noticeDetailId === p?.id
                                )
                              ]?.Saved !== true
                                ? "lemonchiffon"
                                : "greenyellow",
                          }}
                          key={p.id}
                        >
                          <td style={{ width: "20%" }}>{p.title}</td>

                          <td style={{ width: "15%" }}>
                            {p.forceSupply === false ? (
                              <>
                                <div className="mt-1 card px-2 ">
                                  <div style={{ display: "inline-flex" }}>
                                    <Input
                                      ref={(element: any) =>
                                        (inputRef.current[p.id] = element)
                                      }
                                      style={{
                                        display: "inline-flex",
                                        color:
                                          failed === p.id ? "red" : "black",
                                      }}
                                      name="count"
                                      onChange={(d) =>
                                        SetAnswereForNoticeDetail(
                                          p.id,
                                          d.target.name,
                                          d.target.value
                                        )
                                      }
                                      value={
                                        (getAnsweres[
                                          getAnsweres.findIndex(
                                            (f: any) =>
                                              f?.noticeDetailId === p?.id
                                          )
                                        ]?.count === 0
                                          ? p.count
                                          : getAnsweres[
                                              getAnsweres.findIndex(
                                                (f: any) =>
                                                  f?.noticeDetailId === p?.id
                                              )
                                            ]?.count
                                        )
                                          ?.toString()
                                          ?.replace(/[^0-9]/g, "")
                                          ?.replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || ""
                                      }
                                      placeholder="واحد"
                                      bordered={false}
                                    />
                                    از
                                    <Input
                                      style={{ display: "inline-flex" }}
                                      name="count"
                                      onChange={(d) =>
                                        SetAnswereForNoticeDetail(
                                          p.id,
                                          d.target.name,
                                          d.target.value
                                        )
                                      }
                                      disabled
                                      value={p.count
                                        ?.toString()
                                        ?.replace(/[^0-9]/g, "")
                                        ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                      placeholder="واحد"
                                      bordered={false}
                                    />
                                  </div>
                                </div>
                                <div
                                  style={{
                                    color: "red",
                                    display: failed === p.id ? "block" : "none",
                                  }}
                                >
                                  مقدار مورد نیاز نمیتواند از
                                  <b>
                                    {p.count
                                      ?.toString()
                                      ?.replace(/[^0-9]/g, "")
                                      ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  </b>
                                  بیشتر باشد
                                </div>
                              </>
                            ) : (
                              <>
                                <Input
                                  name="count"
                                  onChange={(d) =>
                                    SetAnswereForNoticeDetail(
                                      p.id,
                                      d.target.name,
                                      d.target.value
                                    )
                                  }
                                  disabled
                                  value={p.count
                                    ?.toString()
                                    ?.replace(/[^0-9]/g, "")
                                    ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                  placeholder="واحد"
                                  bordered={true}
                                />
                              </>
                            )}
                          </td>
                          <td style={{ width: "5%" }}>
                            {
                              // Units[
                              //   Units.findIndex(
                              //     (f: any) => f.value === p.unit?.toString()
                              //   )
                              // ].label
                              p.unit
                            }
                          </td>

                          <td style={{ width: "6%" }}>
                            <span>{p.vat * 100}</span>
                            {"%"}
                          </td>

                          <td style={{ width: "10%" }}>
                            <Input
                              name="price"
                              onChange={(d) =>
                                SetAnswereForNoticeDetail(
                                  p.id,
                                  d.target.name,
                                  d.target.value
                                )
                              }
                              value={getAnsweres[
                                getAnsweres.findIndex(
                                  (f: any) => f?.noticeDetailId === p?.id
                                )
                              ]?.price
                                ?.toString()
                                ?.replace(/[^0-9]/g, "")
                                ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              placeholder="قیمت واحد"
                              bordered={true}
                            />
                          </td>

                          <td style={{ width: "10%" }}>
                            <Input
                              disabled
                              value={getAnsweres[
                                getAnsweres.findIndex(
                                  (f: any) => f?.noticeDetailId === p?.id
                                )
                              ]?.totalPrice
                                ?.toString()
                                ?.replace(/[^0-9]/g, "")
                                ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              bordered={false}
                            />
                          </td>
                          <td>
                            <Input
                              disabled
                              value={getAnsweres[
                                getAnsweres.findIndex(
                                  (f: any) => f?.noticeDetailId === p?.id
                                )
                              ]?.totalVat
                                ?.toString()
                                ?.replace(/[^0-9]/g, "")
                                ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              bordered={false}
                            />
                          </td>
                          <td style={{ width: "10%" }}>
                            <Input
                              disabled
                              value={getAnsweres[
                                getAnsweres.findIndex(
                                  (f: any) => f?.noticeDetailId === p?.id
                                )
                              ]?.totalPriceWithVat
                                ?.toString()
                                ?.replace(/[^0-9]/g, "")
                                ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              bordered={false}
                            />
                          </td>
                          <td>
                            <Input
                              name="description"
                              onChange={(d) =>
                                SetAnswereForNoticeDetail(
                                  p.id,
                                  d.target.name,
                                  d.target.value
                                )
                              }
                              value={
                                getAnsweres[
                                  getAnsweres.findIndex(
                                    (f: any) => f?.noticeDetailId === p?.id
                                  )
                                ]?.description
                              }
                              placeholder="توضیحات"
                              bordered={true}
                            />
                          </td>
                          <td>
                            <Button
                              onClick={() => SaveAnswereForNoticeDetail(p.id)}
                              //style={{ color: "white", backgroundColor: "green" }}
                              disabled={
                                getAnsweres[
                                  getAnsweres.findIndex(
                                    (f: any) => f?.noticeDetailId === p?.id
                                  )
                                ]?.Saved !== false
                              }
                              style={{
                                color:
                                  getAnsweres[
                                    getAnsweres.findIndex(
                                      (f: any) => f?.noticeDetailId === p?.id
                                    )
                                  ]?.Saved !== false
                                    ? "white"
                                    : "white",
                                backgroundColor:
                                  getAnsweres[
                                    getAnsweres.findIndex(
                                      (f: any) => f?.noticeDetailId === p?.id
                                    )
                                  ]?.Saved !== false
                                    ? "gray"
                                    : "green",
                              }}
                              type="default"
                              icon={<CheckOutlined />}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};
export default Chat2;
